export * from './button';
export * from './dialog';
export * from './form';
export * from './loading-indicator';
export * from './modal';
export * from './pop-under';
export * from './tooltip';
export * from './track-viewport-dimensions';

import styles from './index.module.scss';
import utility_inner from './utility.module.scss';
import { VNode, h } from 'vue';

export const utility = utility_inner;

export const body = (children: Array<string | VNode> = []): VNode => h('div', { class: 'body' }, children);

export const svg = (innerHTML: string): VNode => h('div', { class: [utility.no_interact_with_children, 'svg'], innerHTML });

export const img = (src: string, alt = 'image', classes: string[] = []): VNode => h('div', { class: [ utility.no_interact_with_children, styles.img, ...classes ] }, h('img', { src, alt, class: classes }));

export const aimg = (
    href: string,
    in_new_tab: boolean,
    src: string,
    alt = 'image',
    classes: string[] = []
): VNode => h('a', {
    class: [ utility.do_interact, ...classes ],
    href,
    target: in_new_tab ? '_blank' : '_self',
}, h('img', { src, alt, class: classes }));
